import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useNavigate } from 'react-router'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'
import { useLogEvent } from '~/hooks/useLogEvent'

import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { useCloneDocumentReportMutation } from '../hooks/useCloneDocumentReportMutation'
import { type InputValues } from '../utils'

export const DocumentReportCloneButton = () => {
  const {
    formState: { isDirty },
  } = useFormContext<InputValues>()

  const navigate = useNavigate()
  const brandAccountId = useBrandAccountId()
  const logEvent = useLogEvent()
  const cloneDocumentReportMutation = useCloneDocumentReportMutation({
    onSuccess: (documentReportId) => {
      navigate(
        compile('documentReportEdit', { brandAccountId, documentReportId }),
      )
      logEvent('Copy document')
    },
  })
  const handleClick = React.useCallback<EH<IconButtonProps, 'onClick'>>(() => {
    cloneDocumentReportMutation.mutate()
  }, [cloneDocumentReportMutation])

  return (
    <IconButton
      disabled={isDirty || cloneDocumentReportMutation.isPending}
      fillMode="outline"
      icon="copy"
      onClick={handleClick}
    />
  )
}
